import React, { useMemo, useState } from 'react'
import { Button } from "@/components/ui/button"
import { Card } from "@/components/ui/card"
import { InvoiceReminders } from '@/types/system-setting/system-config'
import { useGetEmailTemplatesQuery } from '@/services/systemConfigApi'

const WorkflowReminder = ({ workflow }: { workflow: InvoiceReminders }) => {
    const workflowReminders = workflow?.reminders || []

    const { data: emailTemplatesData } = useGetEmailTemplatesQuery({
        query: '',
    })

    const emailTemplates = useMemo(() => {
        return Array.isArray(emailTemplatesData?.data) ? emailTemplatesData?.data : [];
    }, [emailTemplatesData]);

    return (
        emailTemplates.length > 0 && <div className="">
            {workflowReminders.map((reminder, index) => (
                <div key={reminder.id} className="flex  relative">
                    {/* First reminder: line only extends downward */}
                    {index === 0 && <div className="absolute left-1 top-1/2 bottom-0 w-px bg-gray-200"></div>}

                    {/* Middle reminders: line extends both ways */}
                    {index > 0 && index < workflowReminders.length - 1 && (
                        <div className="absolute left-1 top-0 bottom-0 w-px bg-gray-200"></div>
                    )}

                    {/* Last reminder: line only extends upward */}
                    {index === workflowReminders.length - 1 && index !== 0 && (
                        <div className="absolute left-1 top-0 bottom-1/2 w-px bg-gray-200"></div>
                    )}

                    {/* Connection point centered vertically on the card */}
                    <div className="absolute left-1 top-1/2 w-2 h-2 rounded-full bg-gray-300 -translate-x-1 -translate-y-1 z-10"></div>

                    {/* Horizontal line connecting to card */}
                    <div className="absolute left-2 top-1/2 w-7 h-px bg-gray-200 -translate-y-px"></div>

                    <div className="w-10"></div>

                    <div className="py-2 w-full">

                        <Card className="flex-1 p-3 shadow-sm">
                            <h2 className="text-lg font-medium text-gray-700 mb-3">Reminder {index + 1}</h2>
                            <div className="space-y-2">
                                <div>
                                    <span className="text-sm text-gray-500">Trigger: </span>
                                    <span className="text-sm text-primary">{reminder.days} Days - {reminder.trigger}</span>
                                </div>
                                <div>
                                    <span className="text-sm text-gray-500">Email: </span>
                                    <span className="text-sm text-gray-400">
                                        {emailTemplates.find(temp => temp.id === reminder.email_template_id)?.name ?? 'No template selected'}
                                    </span>
                                </div>
                            </div>
                        </Card>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default WorkflowReminder